import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@cp/ds/src/components/button';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { ClientStatus } from '@common/model/client/status';
import { coreClientApi } from 'src/entities/client';
import { useToggleClientBan } from '../model';

export interface ClientDeleteButtonProps extends ButtonProps {
  clientId?: number;
}

export const ToggleBanButton: React.FC<ClientDeleteButtonProps> = ({ clientId, ...props }) => {
  const [disabled, setDisabled] = useState(!clientId);
  const { data: profile } = coreClientApi.endpoints.getClient.useQuery({ id: clientId! }, { skip: !clientId });
  const toggleBan = useToggleClientBan();
  const onClick = useCallback(async () => {
    if (!clientId) {
      return;
    }
    setDisabled(true);
    await toggleBan(clientId);
    setDisabled(!clientId);
  }, [clientId, toggleBan]);

  useEffect(() => {
    setDisabled(!clientId);
  }, [clientId]);

  return (
    <Button disabled={disabled} onClick={onClick} title="Блокирует клиенту всю активность на сервисе" {...props}>
      {profile?.status === ClientStatus.Banned ? 'Разбанить' : 'Забанить'}
    </Button>
  );
};
